module.exports = __webpack_public_path__ + "img/voodoo-black.9278fb6f.svg";